import React from 'react';
import { Button } from 'shards-react';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';
import type { MillSheetType } from '../../../types/millSheetSearch';

interface DownloadButtonProps {
  isDownloadable: boolean;
  isDownloading: boolean;
  onDownload: () => void;
}

const DownloadButton = ({ isDownloadable, isDownloading, onDownload }: DownloadButtonProps): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <Button block theme="primary" className="mb-0 mr-1" disabled={!isDownloadable || isDownloading} onClick={onDownload}>
      {!isDownloading ? (
        t('millSheet.download')
      ) : (
        <>
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-1" />
          {t('millSheet.download')}
        </>
      )}
    </Button>
  );
};

export default DownloadButton;
